// import React, { useState, useEffect, useRef } from "react";
// import usePageTracking from "../hooks/usePageTracking";
// import Header from "./Header";
// import axios from "axios";
// import environment from "../environment";
// import { getStorage, getHeaders } from "../utils/apiUtils";
// import "./LenderSuccessPage.css";
// import loanformalities from "../assets/images/loanformalities.svg";
// import HealthGuardiansicon from "../assets/images/HealthGuardiansicon.svg";
// import NetworkHospital from "../assets/images/NetworkHospital.svg";
// import Pay from "../assets/images/Pay.svg";
// import ChooseEMI from "../assets/images/ChooseEMI.svg";
// // import juspayLogo from "../assets/images/juspaylogo.svg";    

// // import juspayLogo1 from "../assets/images/juspaylogo1.svg";

// const LenderSuccessPage = () => {
//   const [lenderDetail, setLenderDetail] = useState({});
//   const [externalUrl, setExternalUrl] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const hasFetchedRef = useRef(false);

//   // Track page visit
//   usePageTracking("lender-success");

//   // Fetch lender detail from localStorage
//   useEffect(() => {
//     const lenderDetailData = localStorage.getItem('lenderDetail');
//     console.log('lenderDetailData', lenderDetailData);
//     if (lenderDetailData) {
//       try {
//         setLenderDetail(JSON.parse(lenderDetailData));
//       } catch (e) {
//         console.error('Error parsing lenderDetailData:', e);
//         setLenderDetail({});
//       }
//     } else {
//       setLenderDetail({});
//     }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Fetch lender status and external URL from API
//   useEffect(() => {
//     console.log("[LenderSuccessPage] useEffect triggered, hasFetchedRef.current:", hasFetchedRef.current);
    
//     // Prevent duplicate API calls in StrictMode
//     if (hasFetchedRef.current) {
//       console.log("[LenderSuccessPage] API call already initiated, skipping duplicate call");
//       return;
//     }
//     hasFetchedRef.current = true;
//     console.log("[LenderSuccessPage] Setting hasFetchedRef to true, proceeding with API call");

//     const fetchLenderStatus = async () => {
//       try {
//         console.log("[LenderSuccessPage] Starting fetch_lender_status API call");
//         const applicationId = getStorage("application_id");
//         const token = getStorage("token");
        
//         console.log("[LenderSuccessPage] Application ID:", applicationId);
//         console.log("[LenderSuccessPage] Token exists:", !!token);
//         console.log("[LenderSuccessPage] API URL:", `${environment.apiurl}applications/${applicationId}/fetch_lender_status/`);
        
//         if (!applicationId) {
//           console.error("[LenderSuccessPage] Application ID not found in localStorage");
//           setIsLoading(false);
//           return;
//         }

//         if (!token) {
//           console.error("[LenderSuccessPage] Token not found in localStorage");
//           setIsLoading(false);
//           return;
//         }

//         const apiUrl = `${environment.apiurl}applications/${applicationId}/fetch_lender_status/`;
//         const headers = getHeaders();
        
//         console.log("[LenderSuccessPage] Making POST request to:", apiUrl);
//         console.log("[LenderSuccessPage] Headers:", { ...headers, Authorization: headers.Authorization ? "Bearer ***" : "Missing" });

//         const response = await axios.post(
//           apiUrl,
//           {},
//           { headers }
//         );

//         console.log("[LenderSuccessPage] API Response received:", {
//           status: response?.status,
//           hasData: !!response?.data,
//           hasMsg: !!response?.data?.msg
//         });

//         if (response?.data?.msg) {
//           // Extract external_url from response
//           if (response.data.msg.external_url) {
//             console.log("[LenderSuccessPage] External URL received:", response.data.msg.external_url);
//             setExternalUrl(response.data.msg.external_url);
//           } else {
//             console.warn("[LenderSuccessPage] No external_url in response");
//           }
          
//           if(response.data.msg.lender?.logo_url){
//             console.log("[LenderSuccessPage] Lender logo URL received");
//             setLenderDetail(prev => ({ ...prev, logo: response.data.msg.lender?.logo_url }));
//           }

//           // Also check if status is loan-availed
//           if (response.data.msg.status === "loan-availed") {
//             // Handle loan availed case if needed
//             console.log("[LenderSuccessPage] Loan already availed");
//           }
//         } else {
//           console.warn("[LenderSuccessPage] Response data structure unexpected:", response?.data);
//         }
//       } catch (error) {
//         console.error("[LenderSuccessPage] Error fetching lender status:", {
//           message: error?.message,
//           response: error?.response?.data,
//           status: error?.response?.status,
//           statusText: error?.response?.statusText,
//           config: {
//             url: error?.config?.url,
//             method: error?.config?.method
//           }
//         });
        
//         // Log to window for production debugging
//         if (window && typeof window !== 'undefined') {
//           window.lenderStatusError = {
//             message: error?.message,
//             status: error?.response?.status,
//             data: error?.response?.data,
//             timestamp: new Date().toISOString()
//           };
//         }
//       } finally {
//         setIsLoading(false);
//         console.log("[LenderSuccessPage] API call completed, isLoading set to false");
//       }
//     };

//     // Add a small delay to ensure component is fully mounted
//     const timer = setTimeout(() => {
//       fetchLenderStatus();
//     }, 100);

//     return () => {
//       clearTimeout(timer);
//     };
//   }, []);

//   const handleContinue = () => {
//     // Use external URL from API instead of localStorage
//     if (externalUrl) {
//       window.location.href = externalUrl;
//     } else {
//       // Handle no URL case
//       alert("No lender URL available yet. Please try again later.");
//     }
//   };

//   const steps = [
//     {
//       id: 1,
//       icon: loanformalities,
//       title: "Complete all loan <br> formalities on Juspay",
//       description: "",
//     },
//     {
//       id: 2,
//       icon: HealthGuardiansicon,
//       title: "Our Health Guardians will help with Hospital admissions",
//       description: "",
//     },
//     {
//       id: 3,
//       icon: NetworkHospital,
//       title: "Get treated at our network hospital",
//       description: "",
//     },
//     {
//       id: 4,
//       icon: Pay,
//       title: "Pay your hospital bill via Ayushpay",
//       description: "",
//     },
//     {
//       id: 5,
//       icon: ChooseEMI,
//       title: "Choose an EMI up to 6 months",
//       description: "",
//     },
//   ];

//   return (
//     <div className="lender-success-container">
//       <Header showBackButton={false} />

//       <div className="success-content">
//         {/* Logo Section */}

//         {/* Partner Section */}
//         <div className="partner-section">
//           <div className="partner-info">
//             <h2 className="partner-title">
//               Our partner
//               <br />
//               Juspay will give
//               <br />
//               you a medical loan
//             </h2>
//             <div className="juspay-logo">
//               <span className="juspay-text">
//                     <img src={lenderDetail?.logo} alt="logo" />
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Steps Section */}
//         <div className="steps-section">
//           <h3 className="steps-title">
//             To make it zero cost you
//             <br />
//             will need to -
//           </h3>

//           <div className="steps-list">
//             {steps.map((step) => (
//               <div key={step.id} className="step-item">
//                 <div className="step-icon">
//                   <div className="icon-container">
//                     <img src={step.icon} alt={step.icon} />
//                   </div>
//                 </div>
//                 <div className="step-content">
//                   <p
//                     className="step-text"
//                     dangerouslySetInnerHTML={{ __html: step.title }}
//                   ></p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Fixed Bottom Button */}
//       <div className="fixed-button-container">
//         <button 
//           className="continue-button" 
//           onClick={handleContinue}
//           disabled={isLoading || !externalUrl}
//         >
//           {isLoading ? "LOADING..." : "CONTINUE"}
//         </button>
//         {!isLoading && !externalUrl && (
//           <p style={{ 
//             textAlign: "center", 
//             color: "#666", 
//             fontSize: "14px", 
//             marginTop: "8px" 
//           }}>
//             No lender URL available yet
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };

import React, { useState, useEffect, useRef } from "react";
import usePageTracking from "../hooks/usePageTracking";
import { trackEvent } from "../utils/trackEvent";
import Header from "./Header";
import axios from "axios";
import environment from "../environment";
import { getStorage, getHeaders } from "../utils/apiUtils";
import "./LenderSuccessPage.css";
import loanformalities from "../assets/images/loanformalities.svg";
import HealthGuardiansicon from "../assets/images/HealthGuardiansicon.svg";
import NetworkHospital from "../assets/images/NetworkHospital.svg";
import Pay from "../assets/images/Pay.svg";
import ChooseEMI from "../assets/images/ChooseEMI.svg";
// import juspayLogo from "../assets/images/juspaylogo.svg";    

// import juspayLogo1 from "../assets/images/juspaylogo1.svg";

const LenderSuccessPage = () => {
  const [lenderDetail, setLenderDetail] = useState({});
  const [externalUrl, setExternalUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const hasFetchedRef = useRef(false);

  // Track page visit
  usePageTracking("lender-success");
  useEffect(() => { trackEvent("loan_lender_success_viewed"); }, []);

  // Fetch lender detail from localStorage
  useEffect(() => {
    const lenderDetailData = localStorage.getItem('lenderDetail');
    console.log('lenderDetailData', lenderDetailData);
    if (lenderDetailData) {
      try {
        setLenderDetail(JSON.parse(lenderDetailData));
      } catch (e) {
        console.error('Error parsing lenderDetailData:', e);
        setLenderDetail({});
      }
    } else {
      setLenderDetail({});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch lender status and external URL from API
  useEffect(() => {
    console.log("[LenderSuccessPage] useEffect triggered, hasFetchedRef.current:", hasFetchedRef.current);
    
    // Prevent duplicate API calls in StrictMode
    if (hasFetchedRef.current) {
      console.log("[LenderSuccessPage] API call already initiated, skipping duplicate call");
      return;
    }
    hasFetchedRef.current = true;
    console.log("[LenderSuccessPage] Setting hasFetchedRef to true, proceeding with API call");

    const fetchLenderStatus = async () => {
      try {
        console.log("[LenderSuccessPage] Starting fetch_lender_status API call");
        const applicationId = getStorage("application_id");
        const token = getStorage("token");
        
        console.log("[LenderSuccessPage] Application ID:", applicationId);
        console.log("[LenderSuccessPage] Token exists:", !!token);
        console.log("[LenderSuccessPage] API URL:", `${environment.apiurl}applications/${applicationId}/fetch_lender_status/`);
        
        if (!applicationId) {
          console.error("[LenderSuccessPage] Application ID not found in localStorage");
          setIsLoading(false);
          return;
        }

        if (!token) {
          console.error("[LenderSuccessPage] Token not found in localStorage");
          setIsLoading(false);
          return;
        }

        const apiUrl = `${environment.apiurl}applications/${applicationId}/fetch_lender_status/`;
        const headers = getHeaders();
        
        console.log("[LenderSuccessPage] Making POST request to:", apiUrl);
        console.log("[LenderSuccessPage] Headers:", { ...headers, Authorization: headers.Authorization ? "Bearer ***" : "Missing" });

        const response = await axios.post(
          apiUrl,
          {},
          { headers }
        );

        console.log("[LenderSuccessPage] API Response received:", {
          status: response?.status,
          hasData: !!response?.data,
          hasMsg: !!response?.data?.msg
        });

        if (response?.data?.msg) {
          // Extract external_url from response
          if (response.data.msg.external_url) {
            console.log("[LenderSuccessPage] External URL received:", response.data.msg.external_url);
            setExternalUrl(response.data.msg.external_url);
          } else {
            console.warn("[LenderSuccessPage] No external_url in response");
          }
          
          if(response.data.msg.lender?.logo_url){
            console.log("[LenderSuccessPage] Lender logo URL received");
            setLenderDetail(prev => ({ ...prev, logo: response.data.msg.lender?.logo_url }));
          }

          // Also check if status is loan-availed
          if (response.data.msg.status === "loan-availed") {
            // Handle loan availed case if needed
            console.log("[LenderSuccessPage] Loan already availed");
          }
        } else {
          console.warn("[LenderSuccessPage] Response data structure unexpected:", response?.data);
        }
      } catch (error) {
        console.error("[LenderSuccessPage] Error fetching lender status:", {
          message: error?.message,
          response: error?.response?.data,
          status: error?.response?.status,
          statusText: error?.response?.statusText,
          config: {
            url: error?.config?.url,
            method: error?.config?.method
          }
        });
        
        // Log to window for production debugging
        if (window && typeof window !== 'undefined') {
          window.lenderStatusError = {
            message: error?.message,
            status: error?.response?.status,
            data: error?.response?.data,
            timestamp: new Date().toISOString()
          };
        }
      } finally {
        setIsLoading(false);
        console.log("[LenderSuccessPage] API call completed, isLoading set to false");
      }
    };

    // Add a small delay to ensure component is fully mounted
    const timer = setTimeout(() => {
      fetchLenderStatus();
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleContinue = () => {
    trackEvent("loan_lender_success_cta_clicked", { has_external_url: Boolean(externalUrl) });
    // Use external URL from API instead of localStorage
    if (externalUrl) {
      window.location.href = externalUrl;
    } else {
      // Handle no URL case
      alert("No lender URL available yet. Please try again later.");
    }
  };

  const steps = [
    {
      id: 1,
      icon: loanformalities,
      title: "Complete all loan <br> formalities on Juspay",
      description: "",
    },
    {
      id: 2,
      icon: HealthGuardiansicon,
      title: "Our Health Guardians will help with Hospital admissions",
      description: "",
    },
    {
      id: 3,
      icon: NetworkHospital,
      title: "Get treated at our network hospital",
      description: "",
    },
    {
      id: 4,
      icon: Pay,
      title: "Pay your hospital bill via Ayushpay",
      description: "",
    },
    {
      id: 5,
      icon: ChooseEMI,
      title: "Choose an EMI up to 6 months",
      description: "",
    },
  ];

  return (
    <div className="lender-success-container">
      <Header showBackButton={false} />

      <div className="success-content">
        {/* Logo Section */}

        {/* Partner Section */}
        <div className="partner-section">
          <div className="partner-info">
            <h2 className="partner-title">
              Our partner
              <br />
              Juspay will give
              <br />
              you a medical loan
            </h2>
            <div className="juspay-logo">
              <span className="juspay-text">
                    <img src={lenderDetail?.logo} alt="logo" />
              </span>
            </div>
          </div>
        </div>

        {/* Steps Section */}
        <div className="steps-section">
          <h3 className="steps-title">
            To make it zero cost you
            <br />
            will need to -
          </h3>

          <div className="steps-list">
            {steps.map((step) => (
              <div key={step.id} className="step-item">
                <div className="step-icon">
                  <div className="icon-container">
                    <img src={step.icon} alt={step.icon} />
                  </div>
                </div>
                <div className="step-content">
                  <p
                    className="step-text"
                    dangerouslySetInnerHTML={{ __html: step.title }}
                  ></p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Fixed Bottom Button */}
      <div className="fixed-button-container">
        <button 
          className="continue-button" 
          onClick={handleContinue}
          disabled={isLoading || !externalUrl}
        >
          {isLoading ? "LOADING..." : "CONTINUE"}
        </button>
        {!isLoading && !externalUrl && (
          <p style={{ 
            textAlign: "center", 
            color: "#666", 
            fontSize: "14px", 
            marginTop: "8px" 
          }}>
            No lender URL available yet
          </p>
        )}
      </div>
    </div>
  );
};

export default LenderSuccessPage;


// // export default LenderSuccessPage;
// import React, { useState, useEffect, useRef } from "react";
// import usePageTracking from "../hooks/usePageTracking";
// import Header from "./Header";
// import axios from "axios";
// import environment from "../environment";
// import { getStorage, getHeaders } from "../utils/apiUtils";
// import "./LenderSuccessPage.css";

// import loanformalities from "../assets/images/loanformalities.svg";
// import HealthGuardiansicon from "../assets/images/HealthGuardiansicon.svg";
// import NetworkHospital from "../assets/images/NetworkHospital.svg";
// import Pay from "../assets/images/Pay.svg";
// import ChooseEMI from "../assets/images/ChooseEMI.svg";

// const LenderSuccessPage = () => {
//   const [lenderDetail, setLenderDetail] = useState({});
//   const [externalUrl, setExternalUrl] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);

//   const apiCalledRef = useRef(false);

//   usePageTracking("lender-success");

//   /* -----------------------------
//      Load lenderDetail from storage
//   ------------------------------*/
//   useEffect(() => {
//     const lenderDetailData = localStorage.getItem("lenderDetail");
//     if (lenderDetailData) {
//       try {
//         setLenderDetail(JSON.parse(lenderDetailData));
//       } catch {
//         setLenderDetail({});
//       }
//     }
//   }, []);

//   /* -----------------------------
//      Fetch lender status (FIXED)
//   ------------------------------*/
//   useEffect(() => {
//     let retryTimer;

//     const tryFetch = async () => {
//       if (apiCalledRef.current) return;

//       const applicationId = getStorage("application_id");
//       const token = getStorage("token");

//       // ⛔ STORAGE NOT READY → retry
//       if (!applicationId || !token) {
//         retryTimer = setTimeout(tryFetch, 300);
//         return;
//       }

//       apiCalledRef.current = true;

//       try {
//         const apiUrl = `${environment.apiurl}applications/${applicationId}/fetch_lender_status/`;
//         const headers = getHeaders();

//         const response = await axios.post(apiUrl, {}, { headers });

//         const msg = response?.data?.msg;

//         if (msg?.external_url) {
//           setExternalUrl(msg.external_url);
//         }

//         if (msg?.lender?.logo_url) {
//           setLenderDetail(prev => ({
//             ...prev,
//             logo: msg.lender.logo_url,
//           }));
//         }
//       } catch (error) {
//         console.error("fetch_lender_status failed", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     tryFetch();

//     return () => clearTimeout(retryTimer);
//   }, []);

//   /* -----------------------------
//      Continue handler
//   ------------------------------*/
//   const handleContinue = () => {
//     if (externalUrl) {
//       window.location.href = externalUrl;
//     } else {
//       alert("No lender URL available yet. Please try again.");
//     }
//   };

//   const steps = [
//     { id: 1, icon: loanformalities, title: "Complete all loan <br> formalities on Juspay" },
//     { id: 2, icon: HealthGuardiansicon, title: "Our Health Guardians will help with Hospital admissions" },
//     { id: 3, icon: NetworkHospital, title: "Get treated at our network hospital" },
//     { id: 4, icon: Pay, title: "Pay your hospital bill via Ayushpay" },
//     { id: 5, icon: ChooseEMI, title: "Choose an EMI up to 6 months" },
//   ];

//   return (
//     <div className="lender-success-container">
//       <Header showBackButton={false} />

//       <div className="success-content">
//         <div className="partner-section">
//           <div className="partner-info">
//             <h2 className="partner-title">
//               Our partner
//               <br />
//               Juspay will give
//               <br />
//               you a medical loan
//             </h2>
//             <div className="juspay-logo">
//               {lenderDetail?.logo && (
//                 <img src={lenderDetail.logo} alt="lender-logo" />
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="steps-section">
//           <h3 className="steps-title">
//             To make it zero cost you
//             <br />
//             will need to -
//           </h3>

//           <div className="steps-list">
//             {steps.map(step => (
//               <div key={step.id} className="step-item">
//                 <div className="icon-container">
//                   <img src={step.icon} alt="" />
//                 </div>
//                 <p
//                   className="step-text"
//                   dangerouslySetInnerHTML={{ __html: step.title }}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div className="fixed-button-container">
//         <button
//           className="continue-button"
//           onClick={handleContinue}
//           disabled={isLoading || !externalUrl}
//         >
//           {isLoading ? "LOADING..." : "CONTINUE"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default LenderSuccessPage;
